/**
 * Shared rendering utilities for HTML content in iframes.
 */

/**
 * Inject a click interceptor into HTML content so that all links open in a new tab
 * (via the parent window, not the artifact iframe).
 */
export function injectLinkHandler(html: string): string {
  const script =
    `<script>document.addEventListener('click',function(e){var a=e.target.closest('a');if(!a||!a.href)return;e.preventDefault();(window.top||window).open(a.href,'_blank','noopener,noreferrer');});<` +
    `/script>`;
  if (html.includes('</head>')) return html.replace('</head>', script + '</head>');
  if (html.includes('</body>')) return html.replace('</body>', script + '</body>');
  return html + script;
}
